import React from 'react';

import websitePage from 'hoc/websitePage/websitePage';
import OldPageSectionHeading from 'components/structure/OldPageSectionHeading';

import SectionFinancialStatements from './patterns/SectionFinancialStatements/SectionFinancialStatements';

function FinancialStatements() {
  return (
    <>
      <OldPageSectionHeading
        intlKey="FINANCIAL_STATEMENTS.HEAD.TITLE"
        textAlign="center"
      />
      <SectionFinancialStatements />
    </>
  );
}

export default websitePage({
  routeKey: 'FINANCIAL_STATEMENTS',
})(FinancialStatements);
